import { Pipe, PipeTransform } from '@angular/core';
import { formatDisplayText, TextCaseMode } from '../utils/text-case.utils';

/**
 * Format text in Capital Case or Camel Case per UI Standards.
 *
 * Usage in templates:
 *   {{ value | capitalCase }}                    → "Total Sales" (default)
 *   {{ value | capitalCase:'camel' }}            → "totalSales"
 *   {{ value | capitalCase:'none' }}             → passthrough
 *
 * Used for chart/table headers and any other user-facing display text
 * that comes from data keys or config.
 */
@Pipe({
  name: 'capitalCase',
  standalone: true,
  pure: true,
})
export class CapitalCasePipe implements PipeTransform {
  transform(value: unknown, mode: TextCaseMode = 'capital'): string {
    return formatDisplayText(value, mode);
  }
}
